const columns = [
  {
    name: 'Full Name',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Company',
    selector: (row) => row?.company_tx,
    sortable: true,
    sortField: 'company_tx',
  },

  {
    name: 'Email',
    selector: (row) => row?.email_tx,
    sortable: true,
    sortField: 'email_tx',
  },
  {
    name: 'Phone',
    selector: (row) => row?.phone_tx,
    sortable: true,
    sortField: 'phone_tx',
  },
  {
    name: 'Congregation',
    selector: (row) => row?.user_congregation,
    sortable: true,
    sortField: 'user_congregation',
  }, 
  {
    name: 'Device Count',
    selector: (row) => row?.device_count,
    sortable: true,
    sortField: 'device_count',
  }
];
const mobileColumns = [
  {
    name: 'Full Name',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Company',
    selector: (row) => row?.company_tx,
    sortable: true,
    sortField: 'company_tx',
  },

];

export { columns, mobileColumns };
